export default __webpack_public_path__ + "static/media/cap2.6fc2a431.svg";